<template>
  <div id="app">
    <v-app v-if="showLoading" class="loading">
      <v-progress-circular
        :size="80"
        color="primary"
        indeterminate
      ></v-progress-circular>
      <span class="mt-5">در حال دریافت اطلاعات,لطفا منتظر بمانید...</span>
    </v-app>
    <v-app id="inspire" v-else>
      <!-- <v-expansion-panels class="my-5 px-2" elevation="13">
        <v-expansion-panel>
          <v-expansion-panel-header color="#005bdd21">
            <h6 class="text-right">جستجو</h6>
          </v-expansion-panel-header>
          <v-expansion-panel-content color="#005bdd21">
            <div class="row pa-md-8">
              <div
                v-for="header in headers"
                :key="header.text"
                class="col-md-3 mb-5"
                v-show="
                  header.value !== 'isActive' && header.value !== 'actions'
                "
              >
                <div
                  v-if="filters.hasOwnProperty(header.value)"
                  class="filter-items"
                >
                  <date-picker
                    v-model="date"
                    v-if="header.value == 'insertDate'"
                    :show="showDatepicker"
                    @close="closeDatePicker"
                  >
                    <template #icon></template>
                  </date-picker>
                  <v-text-field
                    v-model="date"
                    placeholder="تاریخ"
                    clearable
                    v-if="header.value == 'insertDate'"
                    @click="showDate"
                    class="text-right"
                    reverse
                  ></v-text-field>
                  <v-autocomplete
                    v-else
                    flat
                    hide-details
                    attach
                    dense
                    clearable
                    :items="columnValueList(header.value)"
                    v-model="filters[header.value]"
                    class="text-right"
                    :placeholder="header.text"
                  >
                  </v-autocomplete>
                </div>
              </div>
              <div class="col-md-3 mb-5">
                <button class="btn filter-btn" @click="filterList">
                  فیلتر کردن
                </button>
              </div>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels> -->
      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="filteredDesserts"
        :page.sync="page"
        :items-per-page="itemsPerPage"
        hide-default-footer
        class="table"
        @page-count="pageCount = $event"
        item-key="name"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-row>
              <v-toolbar-title>محصولات تایید نشده</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-text-field
          :value="itemsPerPage"
          label="تعداد آیتم"
          type="number"
          min="-1"
          max="15"
          @input="itemsPerPage = parseInt($event, 10)"
          style="max-width:200px"
        ></v-text-field>
            </v-row>
            <v-dialog v-model="dialogDelete" max-width="500px">
              <v-card>
                <v-card-title class="text-h5">
                  <v-icon color="amber darken-1" class="ml-2">info</v-icon>
                  <p class="ma-0">
                    آیا مطمینید میخواهید آیتم مورد نظر را حذف کنید؟
                  </p>
                </v-card-title>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="#00932a"
                    class="green lighten-4"
                    outline
                    text
                    @click="deleteItemConfirm"
                    >تایید کردن</v-btn
                  >
                  <v-btn
                    color="#b90000"
                    class="red lighten-4 mr-2"
                    text
                    @click="closeDelete"
                    >لغو کردن</v-btn
                  >
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog v-model="dialogShow" max-width="500px">
              <v-card>
                <v-card-title class="text-h5">
                  <v-icon color="amber darken-1" class="ml-2">info</v-icon>
                  <p class="ma-0">آیا مطمئن هستید قصد تغییر وضعیت دارید؟</p>
                </v-card-title>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="#00932a"
                    class="green lighten-4"
                    outline
                    text
                    @click="toggleActivation"
                    >تایید کردن</v-btn
                  >
                  <v-btn
                    color="#b90000"
                    class="red lighten-4 mr-2"
                    text
                    @click="dialogShow = false"
                    >لغو کردن</v-btn
                  >
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog v-model="dialogCard" max-width="500px">
              <v-card>
                <v-card-title>
                  <v-icon color="amber darken-1">mdi-hotel</v-icon>
                  <p class="ma-0">
                    عنوان : <span>{{ card.title }}</span>
                  </p> </v-card-title
                ><v-divider></v-divider>
                <v-card-text class="mt-5 card-info-content">
                  <div class="mt-3">
                    <v-icon class="font-weight-bold" color="amber darken-1"
                      >mdi-person</v-icon
                    >
                    <span class="ma-0"
                      >نام : <span>{{ card.name }}</span></span
                    >
                  </div>
                  <div class="mt-3">
                    <v-icon class="font-weight-bold" color="amber darken-1"
                      >mdi-number</v-icon
                    >
                    <span class="ma-0"
                      >تعداد : <span>{{ card.count }}</span></span
                    >
                  </div>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="#00932a"
                    class="green lighten-4"
                    outline
                    text
                    @click="dialogCard = false"
                    >تایید کردن</v-btn
                  >
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>

        <template v-slot:[`item.isActive`]="{ item }">
          <v-chip
            :color="item.isActive ? '#00C853' : '#FF8F00'"
            text-color="white"
            small
            >{{ item.isActive ? " فعال" : "غیرفعال" }}</v-chip
          >
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="9FA8DA"
                v-bind="attrs"
                v-on="on"
                class="ml-1"
                @click="showInfo(item)"
              >
                mdi-eye-settings
              </v-icon>
            </template>
            <span>مشاهده</span>
          </v-tooltip>
          <!-- <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="9FA8DA"
                @click="getUser(item)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-pencil
              </v-icon>
            </template>
            <span>ویرایش</span>
          </v-tooltip> -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="9FA8DA"
                class="mr-1 9FA8DA"
                @click="deleteItem(item)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-delete
              </v-icon>
            </template>
            <span>حذف</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="9FA8DA"
                class="mr-1 9FA8DA"
                @click="ToggleItem(item)"
                v-bind="attrs"
                v-on="on"
                >mdi-rotate-3d-variant</v-icon
              >
            </template>
            <span>تغییر وضعیت</span>
          </v-tooltip>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary"> ریکوردی یافت نشد </v-btn>
        </template>
      </v-data-table>
      <div class="text-center pt-2">
        <v-pagination v-model="page" :length="pageCount" ></v-pagination>
        
      </div>
    </v-app>
  </div>
</template>


<script>
import axios from "axios";
import baseURL from "@/axios";
export default {
  data: () => ({
    page: 1,
        pageCount: 0,
        itemsPerPage: 10,
    showLoading: false,
    dialogDelete: false,
    dialogShow: false,
    dialogCard: false,
    selected: [],
    date: null,
    showCase: null,
    showId: null,
    todatevalue: null,
    fromdatevalue: null,
    showDatepicker: false,
    headers: [
      {
        text: "عنوان محصول",
        align: "right",
        value: "title",
      },
      {
        text: "وضعیت نمایش",
        align: "right",
        value: "isShow",
      },
      {
        text: "نام فروشنده",
        align: "right",
        value: "provideTitle",
      },
      { text: "تنظیمات", value: "actions", sortable: false, align: "left" },
    ],
    filters: {
      name: [],
      count: [],
    },
    card: {
      title: null,
      email: null,
      geoDivisionTitle: null,
      mobile: null,
      isActive: null,
      typeTitle: null,
    },
    typeId: 0,
    desserts: [],
  }),
  created() {
    this.showLoading = true;
    axios
      .get(`${baseURL}Product/GetAllNotApproved`, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        this.showLoading = false;
        this.listData1 = response.data.data;
        this.listData1.map((item) => {
          item.insertDate = new Date(item.insertDate).toLocaleDateString(
            "fa-IR"
          );
          this.desserts.push({
            title: item.title,
            id: item.id,
            isShow: item.isConfirm,
            provideTitle: item.providerTitle,
          });
        });
      })

      .catch(() => {
        this.showLoading = false;
      });
  },
  computed: {
    filteredDesserts() {
      return this.desserts.filter((d) => {
        return Object.keys(this.filters).every((f) => {
          return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
        });
      });
    },
  },

  methods: {
    closeDatePicker() {
      this.showDatepicker = false;
    },
    showDate() {
      this.showDatepicker = true;
    },
    async filterList() {
      this.showLoading = true;
      this.date = [];
      if (this.date[1]) {
        this.todatevalue = this.date[1];
        this.fromdatevalue = this.date[0];
      }
      this.desserts.map((item) => {
        if (this.filters.typeTitle == item.typeTitle) {
          this.typeId = item.typeId;
          ////////console.log(item.typeId);
        }
      });
    },
    columnValueList(val) {
      return this.desserts.map((d) => d[val]);
    },
    deleteItem(item) {
      this.deleteId = item.id;
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    async deleteItemConfirm() {
      this.showLoading = true;
      await axios
        .delete(`${baseURL}ShippingPrice/Delete?id=${this.deleteId}`, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        })
        .then(() => {
          this.showLoading = false;
          this.desserts.splice(this.editedIndex, 1);
        })
        .catch(() => {
          this.showLoading = false;
        });
      this.closeDelete();
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    ToggleItem(item) {
      this.showId = item.id;
      this.showCase = item;
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogShow = true;
    },

    showInfo(item) {
      // this.card.title = item.name;
      // this.card.mobile = item.mobile;
      // this.card.email = item.email;
      // this.card.geoDivisionTitle = item.geoDivisionTitle;
      // this.card.isActive = item.isActive;
      // this.card.typeTitle = item.typeTitle;
      // ////////console.log(this.card);
      // this.dialogCard = true;
      this.$router.push(`/product-management/NotApproved/show/${item.id}`);
    },

    getUser(item) {
      this.$router.push(`/product-management/NotApproved/edit/${item.id}`);
    },
    toggleActivation() {
      axios
        .put(
          `${baseURL}Product/ChangeConfirmationStatus?id=${this.showCase.id}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        )
        .then(() => {
          this.desserts = [];
          this.showLoading = true;
          axios
            .get(`${baseURL}Product/GetAllNotApproved`, {
              headers: {
                Authorization: `Bearer ${sessionStorage.getItem("token")}`,
              },
            })
            .then((response) => {
              this.showLoading = false;
              this.listData1 = response.data.data;
              this.listData1.map((item) => {
                item.insertDate = new Date(item.insertDate).toLocaleDateString(
                  "fa-IR"
                );
                this.desserts.push({
                  title: item.title,
                  id: item.id,
                  isShow: item.isConfirm,
                  provideTitle: item.providerTitle,
                });
              });
            })

            .catch(() => {
              this.showLoading = false;
            });
          this.dialogShow = false;
        });
    },
  },
};
</script>


<style>
.pdp .pdp-group {
  display: none;
}
.filter-items .v-input {
  padding: 0 !important;
  margin: 0 !important;
}
.filter-btn {
  background: #001f4b;
  color: #fff;
}
.v-select__slot input,
.v-text-field__slot input {
  font-size: 13px;
  color: #5f5f5f !important;
}
.ff0000--text {
  color: #ff0000 !important;
  background: #ff00002e !important;
  border-radius: 5px;
}
.ffb100--text {
  color: #ffb100 !important;
  background: #ffb1002b;
  border-radius: 5px;
}

.show--text {
  color: #29b6f6 !important;
  background: #29b6f62b;
  border-radius: 5px;
}
.toogle-icon--text {
  color: #512da8 !important;
  background: #522da848;
  border-radius: 5px;
}
.v-application .text-h5 {
  font-family: "iransans", "yekan", "vazir" !important;
}
.loading .v-application--wrap {
  justify-content: center;
  align-items: center;
}
.card-info-content span {
  font-size: 15px;
}
</style>

